import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckCircle2Icon } from 'lucide-react';
import { MOCKUP_IMG } from '../data/product';
const highlights = ['Visual Exercises', 'Ready-to-Teach Classes', 'Professional Circuits', 'Structured Progressions', 'Long-Term Programming'];
export function Hero() {
  return <section className="bg-ink text-white px-4 sm:px-6 pt-5 pb-8 sm:pt-10 sm:pb-12" data-id="element-88" data-mp="4n1j0kwg00pc">
      <div className="max-w-4xl mx-auto text-center" data-id="element-89" data-mp="128fsxs72atzx">
        <p className="inline-flex items-center gap-1.5 rounded-full border border-lime/40 bg-lime/10 px-3 py-1 mb-3.5 font-heading font-bold text-[9px] sm:text-[11px] uppercase tracking-[0.16em] text-lime" data-id="element-90" data-mp="xae9351taqne">
          <span className="w-1 h-1 rounded-full bg-lime" data-id="element-91" data-mp="nc85mj0cxcgf" />
          The complete 6-in-1 senior fitness system
        </p>

        <h1 className="font-heading font-black uppercase leading-[1.05] tracking-tight text-[1.35rem] sm:text-3xl lg:text-5xl mb-2.5" data-id="element-92" data-mp="3d1scj2wkntvr">
          Your senior fitness programming.{' '}
          <span className="text-lime" data-id="element-93" data-mp="3j8sgk46tfprf">Already organized.</span>
        </h1>

        <p className="text-[13px] sm:text-base font-semibold text-white/85 leading-snug mb-1.5" data-id="element-94" data-mp="3j6od1nctwsro">
          Stop rebuilding classes every week.
        </p>
        <p className="text-[13px] sm:text-base text-white/70 leading-snug max-w-xl mx-auto mb-4" data-id="element-95" data-mp="399jmlbbyab52">
          Open the system, choose what fits your group, adapt it when needed,
          and coach with a clear plan.
        </p>

        <ul className="flex flex-wrap justify-center gap-1.5 mb-4" data-id="element-96" data-mp="30fy87t3p6vw6">
          {highlights.map(item => <li key={item} className="flex items-center gap-1 rounded bg-white/[0.06] border border-white/10 px-2 py-1 text-[10px] sm:text-xs font-semibold text-white/80" data-id="element-97" data-mp="35aklk1tcayiw">
              <CheckCircle2Icon className="w-3 h-3 text-lime shrink-0" data-id="element-98" data-mp="2hj5drtisnp09" />
              {item}
            </li>)}
        </ul>

        <a href="#pricing" className="block cursor-pointer mb-4" data-id="element-99" data-mp="2ljpawx3dasme">
          <img src={MOCKUP_IMG} alt="Fitness Senior Ready 6-in-1 system shown across desktop, tablet, phone, and six printed module guides" className="w-full max-w-xs sm:max-w-lg lg:max-w-2xl mx-auto object-contain hover:scale-[1.01] transition-transform duration-300 ease-out" data-id="element-100" data-mp="s21k8hdb6o2m" />
        </a>

        <p className="font-heading font-bold text-[10px] sm:text-xs uppercase tracking-[0.12em] text-gold mb-3" data-id="element-101" data-mp="de6r4zve2hp0">
          1 Complete System · 6 Professional Modules · 5 Premium Bonuses
        </p>

        <div className="max-w-xs sm:max-w-sm mx-auto mb-2.5" data-id="element-102" data-mp="162ubmt8bd31i">
          <CTAButton data-id="element-103" data-mp="112g3zcamjv40">Get Fitness Senior Ready™</CTAButton>
        </div>

        <p className="text-[10px] sm:text-xs font-semibold text-white/55 tracking-wide" data-id="element-104" data-mp="114suidug7dso">
          One-Time Payment · Instant Digital Access · 7-Day Guarantee
        </p>
      </div>
    </section>;
}